export const isIE = () => navigator.userAgent.match(/Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/) ||
    navigator.userAgent.match(/MSIE\s([0-9\.]+);.*Trident\/[4-7].0/) ||
    navigator.userAgent.match(/MSIE\s(7\.0)/);
export const isFirefox = () => navigator.userAgent.match(/Firefox\/([0-9\.]+)(?:\s|$)/) &&
    !navigator.userAgent.match(/Seamonkey\/([0-9\.]+)(?:\s|$)/);
//# sourceMappingURL=detect-browser.js.map